import CaseHealthListItem from "./CaseHealthListItem";

export default function CaseHealthList({ data }) {
  return (
    data &&
    data.map((item, index) => (
      <div className="p-2">
        <CaseHealthListItem issue={item} />
      </div>
    ))
  );
}
